export default {
  login: 1,
  forgot: 1,
  forgotChangePassword: 1,
  cadMonitoring: 1,
};
